import { render, staticRenderFns } from "./practiceInforSecond.vue?vue&type=template&id=79452ee0&scoped=true&"
import script from "./practiceInforSecond.vue?vue&type=script&lang=js&"
export * from "./practiceInforSecond.vue?vue&type=script&lang=js&"
import style0 from "./practiceInforSecond.vue?vue&type=style&index=0&id=79452ee0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79452ee0",
  null
  
)

export default component.exports